<template>
  <b-card>
      <b-form class="patient-form">
      <b-row>
        <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1">
          <b-button v-on:click="resetFilter" size="sm" variant="secondary">
            <font-awesome-icon icon="times" />
            {{ $t('Сброс') }}
          </b-button>
        </b-col>
        <filter-select
          :labelCols="4"
          :label="$t('Автор')"
          v-on:onChange="search"
          :cols="2"
          v-model="form.authorId"
          :options="authors"
          class="small-padding"
        ></filter-select>
        <filter-input
          :labelCols="4"
          :label="$t('Пациент')"
          v-on:onBlur="search"
          :cols="2"
          v-model="form.description"
          class="small-padding"
        ></filter-input>
        <filter-date-picker
          :labelCols="6"
          :label="$t('Год рождения')"
          v-on:onChange="search"
          format="YYYY"
          type="year"
          :cols="2"
          v-model="birthdayDate"
          class="small-padding"
        ></filter-date-picker>
        <filter-select
          :labelCols="3"
          :label="$t('Статус')"
          v-on:onChange="search"
          v-on:input="search"
          :cols="2"
          v-model="form.statuses"
          :multiple="true"
          :empty-as-null="true"
          :options="statusesList"
          class="small-padding"
        ></filter-select>
        <filter-date-range
          :labelCols="5"
          :label="$t('Дата создания')"
          v-on:onChange="search"
          :cols="3"
          v-model="createDateRange"
          class="small-padding"
        ></filter-date-range>
      </b-row>
      <b-row>
        <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
        <filter-select
          :labelCols="4"
          v-on:onChange="search"
          :cols="4"
          :label="$t('Координатор Центра')"
          v-model="form.operatorId"
          :options="operators"
          class="small-padding"
        ></filter-select>
        <filter-select
          :label="$t('Код ТЦ / КЦ')"
          @onChange="search"
          :cols="2"
          :labelCols="4"
          class="tc-code small-padding"
          v-model="form.tcOrganizationId"
          :options="tcOrganizations"
          :disabled="$auth.user().isTc"
        ></filter-select>
        <filter-checkbox
          :label="$t('Семейное обследование')"
          v-model="form.isRelatives"
          v-if="canWorkWithRelativePatients()"
          v-on:onChange="changeIsRelatives"
        ></filter-checkbox>
        <filter-date-range
          :labelCols="5"
          :label="$t('Дата изм. сост.')"
          v-on:onChange="search"
          :cols="3"
          v-model="updateDateRange"
          class="small-padding"
        ></filter-date-range>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    lastName: String,
    createDateFrom: String,
    createDateTo: String,
    updateDateFrom: String,
    updateDateTo: String,
    statuses: String,
    description: String,
    authorId: String,
    birthday: String,
    isRelatives: String,
    donorId: String,
    patientNumber: String,
    operatorId: String,
    tcOrganizationId: String,
  },
  data() {
    return {
      form: {
        lastName: this.lastName || '',
        createDateFrom: this.createDateFrom,
        createDateTo: this.createDateTo,
        updateDateFrom: this.updateDateFrom,
        updateDateTo: this.updateDateTo,
        statuses: this.statuses || [],
        operatorId: this.operatorId || '',
        description: this.description || '',
        authorId: this.authorId || '',
        donorId: this.donorId || '',
        isRelatives: this.isRelatives == 'true' || false,
        birthday: this.birthday || '',
        patientNumber: this.patientNumber || '',
        tcOrganizationId: this.tcOrganizationId || '',
      },
      statusesList: [],
      operators: [],
      authors: [],
      createDateRange: [],
      updateDateRange: [],
      birthdayDate: '',
      tcOrganizations: [],
      SEARCH_DONOR_STATUS: 2,
    };
  },
  mounted() {
    const createDateFrom = this.createDateFrom ? new Date(this.createDateFrom) : this.createDateFrom;
    const createDateTo = this.createDateTo ? new Date(this.createDateTo) : this.createDateTo;
    const updateDateFrom = this.updateDateFrom ? new Date(this.updateDateFrom) : this.updateDateFrom;
    const updateDateTo = this.updateDateTo ? new Date(this.updateDateTo) : this.updateDateTo;

    this.createDateRange = [createDateFrom, createDateTo];
    this.updateDateRange = [updateDateFrom, updateDateTo];
    this.birthdayDate = this.birthday ? new Date(this.birthday) : this.birthday;
  },
  methods: {
    canWorkWithRelativePatients() {
      return this.$auth.user().isRdkm || (this.$auth.user().functions.find(t => t.routeName === 'RelativePatients') != null);
    },
    getDictionaries() {
      const orgId = this.$auth.user().isTc ? this.$auth.user().tcId || this.$auth.user().organizationId : null;
      axios.get('/Dictionary/GetPatientFilterOptions/?id=' + orgId).then((response) => {
        this.authors = response.data.authors;
        this.statusesList = response.data.statuses;
        this.operators = response.data.operators;
        this.tcOrganizations = response.data.tcOrganizations;
      });
    },
    changeIsRelatives() {
      this.form.isRelatives = !this.form.isRelatives;
      if(this.form.isRelatives && this.form.status == this.SEARCH_DONOR_STATUS) {
        this.form.status = '';
      }
      this.search();
    },
    resetFilter(e) {
      this.reset(e, () => {
        this.updateDateRange = '';
        this.createDateRange = '';
        this.birthdayDate = '';
        this.form.tcOrganizationId = this.$auth.user().isTc
          ? this.$auth.user().currentOrganization.id
          : this.form.tcOrganizationId;
      });
    },
  },
  watch: {
    createDateRange: function() {
      this.form.createDateFrom = this.createDateRange[0] ? this.createDateRange[0].toJSON() : '';
      this.form.createDateTo = this.createDateRange[1] ? this.createDateRange[1].toJSON() : '';
      this.search();
    },
    updateDateRange: function() {
      this.form.updateDateFrom = this.updateDateRange[0] ? this.updateDateRange[0].toJSON() : '';
      this.form.updateDateTo = this.updateDateRange[1] ? this.updateDateRange[1].toJSON() : '';
      this.search();
    },
    birthdayDate: function() {
      this.form.birthday = this.birthdayDate ? this.birthdayDate.toJSON() : '';
      this.search();
    },
  },
};
</script>

<style scoped>
h6 {
  line-height: 28px;
}

.tc-code {
  padding-left: 0.65rem;
}

.small-padding {
  padding-right: 0px;
  padding-left: 5px;
}
</style>
